import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Button,
    Card,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AppBar from "@mui/material/AppBar";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import _ from "lodash";
import { default as React, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import {
    nbfCreateNewOrder,
    nbfCustomerByID,
    nbfInvoice,
    nbfNewOrderPayment
} from "../../api/restApi";
import { customersData } from "../../store/reducer/customersSlice";
import {
    ConvertOrderArrayToObject,
    discountPriceItems,
    discountPriceOnArrearsZero,
    resolveUnitPriceForCustomer,
} from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import InvoiceModal from "./InvoiceModal";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NeworderModel({
  detailOpen,
  customerId,
  date,
  handleClose,
  handleStatus,
  view,
}) {
  const { customers } = useAppSelector(customersData);
  const [customer, setCustomer] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [paymentMode, setPaymentMode] = useState([
    "EasyPaisa",
    "JazzCash",
    "Account",
    "Cash",
  ]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [discount,setDiscount]=useState(0)
  const name = useSelector((state) => state.currentUser.name);
  const [productsOption, setProductsOption] = useState([]);
  const [selectedProduct,setSelectedProduct]=useState();
  const product = useSelector((state) => state.products.products);

  const [quantity, setQuantity] = useState(0);
  const [TableList, setReturnTableList] = useState([]);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [newOrderByCustomer, setNewOrderByCustomer] = useState("");


  const handleSelectProduct = async (event, newValue) => {
    setSelectedProduct(newValue);
  };

  useEffect(() => {
    setProductsOption([
      ...product.map((data) => {
        data = {
          ...data,
          label: data.name_english + " " + data.name_urdu,
        };
        return data;
      }),
    ]);
  }, [product]);

  const calculateTotalSum = (orderArray) => {
    
    const returnAmount=0;  //*****hard code

    setCustomerInvoiceDetails((pre) => {
      const updatedDetails = {
        ...pre,
        returnAmount:returnAmount,
        grandTotal:
          pre.total - returnAmount - Number.parseInt(discount),
          orderArray,
      };
      return updatedDetails;
    });
    updateAmountPaid(orderArray)
  };
  
  const handleAddProduct = () => {
    if (selectedProduct && quantity > 0) {
      const targetCustomer = selectedCustomer || findCustomer(customerId);
      const unitPrice = resolveUnitPriceForCustomer(selectedProduct, targetCustomer);
      if (unitPrice === undefined || unitPrice === null || unitPrice === "") {
        return;
      }

      let price = unitPrice;
    let orderArray =[]
      const existingProductIndex = TableList.findIndex(
        (item) => item.name_english === selectedProduct.name_english
      );
      if (existingProductIndex !== -1) {
        const updatedTableList = [...TableList];
        updatedTableList[existingProductIndex].quantity = quantity;
        updatedTableList[existingProductIndex].price = price;
        setReturnTableList([...updatedTableList]);
        orderArray=[...updatedTableList]
      } else {
        const newRow = {
          id: selectedProduct.id,
          name_english: selectedProduct.name_english,
          name_urdu:selectedProduct.name_urdu,
          quantity: quantity,
          price: price,
        };
        setReturnTableList([...TableList, newRow]);
        orderArray=[...TableList, newRow]
      }
      setSelectedProduct(null);
      setQuantity(0);
      calculateTotalSum(orderArray)
    }
  }; 
  
  const [customerInvoiceDetails, setCustomerInvoiceDetails] = useState({
    bill: 0,
    arrears: 0,
    return: 0,
    discount: 0,
    amountPaid: 0,
    total: 0,
    grandTotal: 0,
    balance: 0,
    tray: 0,
    paymentMode: "",
    delivery_charges: 0,
    advancePayment: 0,
    user:name,
  });

  const inputRef = useRef(null);
  const textFieldRef = useRef(null);

  async function callData(date) {
    setOpenLoader(true);
    try {
      setCustomer([]);
      setDiscount(0)
      let data = await nbfInvoice(date, customerId);
      console.log(data)
      // if(data.newOrderPayment) && (

      // )
      data = ConvertOrderArrayToObject([data]);
      let customersData = _.find(data.orders_customer, {
        customerId: customerId,
      }); //find by id
      if (!customersData) {
        customersData = _.find(data.orders_customer, {
          customerId: parseFloat(customerId),
        }); //find by id
      }
      let newData = { ...customersData, ...findCustomer(customerId) };
      console.log(newData)
      setSelectedCustomer(newData);
      let disc  = 0
      discountPriceItems.filter((item) => {
        const matchingItem = newData.order?.find(
          (orderItem) => orderItem.id+"" === item.id+""
        );
        if (matchingItem) {
          disc = disc + item.discount * matchingItem.quantity;
        }
        return matchingItem !== undefined;
      });
      if (!discountPriceOnArrearsZero){
        disc=0
      }
      setDiscount(disc)
      setOpenLoader(false);
    } catch {
      setOpenLoader(false);
    }
  }

  const findCustomer = (id) => {
    let cust = customers.find((el) => el.id.toString() === id.toString());
    return {
      ...cust,
      label: cust.name_urdu ? cust.name_urdu : cust.name_english,
    };
  };

  //**********discount ********/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const singleCustomer = await nbfCustomerByID(selectedCustomer.id);
        const order = selectedCustomer.newOrder;
        console.log(selectedCustomer)
        const bill = order.reduce((acc, item) => {
          const price = parseFloat(item.price.toString().replace(/,/g, ""));
          return acc + item.quantity * price;
        }, 0);

        console.log(bill)
        const delivery_charges = 
        singleCustomer.customer.delivery_charges && singleCustomer.customer.delivery_charges ? singleCustomer.customer.delivery_charges : 0;
        const arrears = singleCustomer.payment?.arrearAmount;

        const total =
          parseFloat(bill.toString().replace(/,/g, "")) +
          parseFloat(delivery_charges) +
          parseFloat(arrears);

          console.log(total)
        if (arrears > 0) {
          setDiscount(0)
        }
        const grandTotal =
          arrears <= 0 && discount> 0
            ? parseFloat(total.toString().replace(/,/g, "")) - discount
            : parseFloat(total.toString().replace(/,/g, ""));

        const balance = grandTotal;
        setCustomerInvoiceDetails((pre) => ({
          ...pre,
          arrears,
          delivery_charges,
          bill,
          total,
          grandTotal,
          balance,
          return: 0,
          amountPaid: 0,
          customerId: selectedCustomer.id,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (selectedCustomer) {
      fetchData();
    }
  }, [selectedCustomer]);

  const handleSelectPayment = async (event, newValue) => {
    setSelectedPayment(newValue);
  };

  useEffect(() => {
      date && callData(date);
  }, [date, customerId]);

  const updateAmountPaid = (orderArray) => {
    setCustomerInvoiceDetails((pre) => {
      const updatedDetails = {
        ...pre,

        arrears:pre.arrears,
        amountPaid: inputRef.current?.value,
        balance:
          inputRef.current?.value >= pre.grandTotal
            ? Number.parseInt(0)
            : pre.grandTotal - inputRef.current?.value,
        advancePayment:
          inputRef.current?.value > pre.grandTotal
            ? inputRef.current?.value - pre.grandTotal
            : 0,
      };
      return updatedDetails;
    });
  };
  const newOrderArray= customerInvoiceDetails.orderArray;
  const handleSubmitData = async () => {
    if (!customerInvoiceDetails.return && !customerInvoiceDetails.amountPaid) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Need to add some Payment or return !",
      });
    } else {
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: "Do You want to submit this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Submit it!",
      });
      if (confirmed.isConfirmed) {
        try {
          handleClose();
          await nbfNewOrderPayment(customerInvoiceDetails,customerId);
          toast.success("Successfully Submit Order !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          // handleStatus(date);
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  console.log(TableList)
  const submiteNewOrder=async()=>{
    if(TableList.length!==0){

      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: "Do You want to submit this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Submit it!",
      });

      if (confirmed.isConfirmed) {
        try{   
                await nbfCreateNewOrder(newOrderArray,customerId,date)
                callData(date)
          }
        
      catch (error) {
        console.log(error);
      }}
    }
    else return
    
    }

  
    return (
      <div>
        <Dialog
          fullScreen
          open={detailOpen}
          onClose={handleClose}
          TransitionComponent={Transition}
          style={{ zIndex: 1000 }}
        >
          <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h5" align="center">
              New-Order-Detail
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
          <Box sx={{ flexGrow: 0, padding: "1rem" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Card variant="outlined" sx={{ width: "100%" }}>
                      <Typography
                        sx={{
                          width: "90%",ml:"5%", mt:2,
                          fontWeight: "bold",
                          fontSize: "20px",
                          textAlign:"center"
                        }}
                        color={"green"}
                      >
                        Create New Order
                      </Typography>
            <Card variant="outlined" sx={{ width: "100%",}}>
              <CardContent style={{marginLeft:'1rem'}}>
                <Grid xs={12} md={12} >
                <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem" 
                  >
                  <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        sx={{width:"100%"}}
                        onClick={submiteNewOrder}
                      >
                        SUBMIT
                      </Button>
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                <label style={{ minWidth: "50%" }}>
                <Autocomplete
                  disablePortal
                  label="Select Product"
                  id="combo-box-demo"
                  options={productsOption}
                  sx={{
                    minWidth: "100%",
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  value={ selectedProduct || null}
                  onChange={handleSelectProduct}
                  renderInput={(params) => (
                    <TextField {...params} label="select product" />
                  )}
                />
                  </label>
                    <label style={{ minWidth: "48%" }}>
                    <TextField
                        sx={{ marginTop: '1rem',minWidth:'100%'}}
                        type="number"
                        label="Quantity"
                        value={quantity || ""}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                  </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%", }}>
                      <Button variant="contained" 
                              sx={{minWidth:'100%',}} 
                              onClick={handleAddProduct}>
                        ADD Product
                      </Button>
                    </label>
                  </Stack>
                </Grid>
              </CardContent>
              <Table>
              <TableHead>
                <TableRow >
                  <TableCell align="center">Name English</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                  <TableCell align="center">Name Urdu</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TableList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.name_english}</TableCell>
                    <TableCell align="center">{row.quantity}</TableCell>
                    <TableCell align="center">{row.name_urdu}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </Card>
            </Card>
            </Grid>



            <Grid item xs={12} md={6}>
                {selectedCustomer?.newOrder && selectedCustomer && (
            <Card variant="outlined" sx={{ width: "100%" }}>
                    {selectedCustomer?.newOrder && selectedCustomer &&(
            <Card variant="outlined" sx={{ width: "100%" }}>
              <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Accordion
                    sx={{ width: "100%", background: "lightgray", mt:0}}
                  >
                    <AccordionSummary
                      width="100%"
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        sx={{
                          width: "13%",
                          fontWeight: "bold",
                          fontSize: "20px",
                          marginLeft:"40%",
                          textAlign:"center",
                        }}
                        color={"green"}
                      >
                        
                      </Typography>
                    </AccordionSummary>
                    <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem" 
                  >
                    <label style={{ minWidth: "50%" }}>
                      <Typography sx={{ fontWeight: "bold" , textAlign:'center' }}>
                        {date}
                      </Typography>
                    </label>
                    <label style={{ minWidth: "50%" }}>
                      <Typography sx={{ fontWeight: "bold", textAlign:'center' }}>
                        {selectedCustomer?.name_urdu}
                      </Typography>
                    </label>
                  </Stack>
                  <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem" 
                  >
                  <label style={{ minWidth: "100%" }}>
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        sx={{width:"100%"}}
                        onClick={handleSubmitData}
                      >
                        SUBMIT
                      </Button>
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "50%" }}>
                      <TextField inputRef={inputRef} type="number" label="Payment"
                          sx={{minWidth:'100%' }}
                      />
                    </label>
                    <label style={{ minWidth: "45%" }}>
                      <Autocomplete
                      disablePortal
                      id="combo-box-demo3"
                      options={paymentMode}
                      sx={{minWidth:'100%'}}
                      value={selectedPayment}
                      onChange={handleSelectPayment}
                      renderInput={(params) => (
                        <TextField {...params} label="Mode" />
                      )}
                      />
                    </label>
                  </Stack>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label style={{ minWidth: "100%", }}>
                      <Button variant="contained" 
                              sx={{minWidth:'100%',}} 
                              onClick={updateAmountPaid}>
                        ADD Payment
                      </Button>
                    </label>
                  </Stack>
                </Accordion>  
                </CardContent>
                <Card
                  variant="outlined"
                >
                  <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Table
                        aria-label="simple table"
                        sx={{
                          maxWidth: 300,
                        }}
                      >
                        <TableRow
                          sx={{ backgroundColor: "lightgray", height: "5vh" }}
                        >
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              height: 6,
                              width: "50%",
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.bill}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                              height: 6,
                            }}
                          >
                            بل
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E49393" }}>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.arrears}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                            }}
                          >
                            بقایا جات
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.delivery_charges}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                            }}
                          >
                            ترسیلی چارجز
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "lightgray" }}>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.total}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                            }}
                          >
                            کل
                          </TableCell>
                        </TableRow>
                        {customerInvoiceDetails.returnAmount > 0 && (
                          <TableRow sx={{ backgroundColor: "#E49393" }}>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: 15,
                                padding: 8,
                                textAlign: "justify",
                              }}
                            >
                              {customerInvoiceDetails.returnAmount}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                textAlign: "end",
                                fontWeight: "bold",
                                fontSize: 15,
                                padding: 8,
                              }}
                            >
                              واپسی
                            </TableCell>
                          </TableRow>
                        )}
                        {customerInvoiceDetails.arrears == 0 && discount>0 && (
                          <TableRow sx={{ backgroundColor: "#609EA2" }}>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: 15,
                                padding: 8,
                                textAlign: "justify",
                              }}
                            >
                              {discount}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                textAlign: "end",
                                fontWeight: "bold",
                                fontSize: 15,
                                padding: 8,
                              }}
                            >
                              رعایت
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow sx={{ backgroundColor: "#609EA2" }}>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.grandTotal}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                            }}
                          >
                            کل رقم
                          </TableCell>
                        </TableRow>
                        {customerInvoiceDetails.amountPaid > 0 && (
                          <TableRow>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: 15,
                                padding: 8,
                                textAlign: "justify",
                              }}
                            >
                              {customerInvoiceDetails.amountPaid}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                textAlign: "end",
                                fontWeight: "bold",
                                fontSize: 15,
                                padding: 8,
                              }}
                            >
                              ادائیگی
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow sx={{ backgroundColor: "#E49393" }}>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 15,
                              padding: 8,
                              textAlign: "justify",
                            }}
                          >
                            {customerInvoiceDetails.balance}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              textAlign: "end",
                              fontWeight: "bold",
                              fontSize: 15,
                              padding: 8,
                            }}
                          >
                            بقیہ
                          </TableCell>
                        </TableRow>
                      </Table>
                  </CardContent>
                </Card>
            </Card>
          )}     
                  </Card>
                )}
              </Grid>
            </Grid>
          </Box>
          {/* ... Rest of the code */}
        </Dialog>
    
        {newOrderByCustomer && (
          <InvoiceModal
            openInvoice={openInvoice}
            orderByCustomer={newOrderByCustomer}
            setOpenInvoice={setOpenInvoice}
          />
        )}
      </div>
    );
    
}



